import React from "react";
import PropTypes from "prop-types";

const TooltipIcon = ({
  className,
  height,
  width,
  backgroundColor,
  fill,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g
      id="General-/-Icon-/-Tooltip"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-20">
        <circle id="Oval" fill={backgroundColor} cx="9" cy="9" r="9" />
        <path
          d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM13.5 7.48507C13.5 7.81343 13.4617 8.10199 13.385 8.35075C13.3084 8.5995 13.2006 8.82836 13.0616 9.03731C12.9227 9.24627 12.755 9.44278 12.5585 9.62687C12.3621 9.81095 12.1393 10.0025 11.8901 10.2015C11.7368 10.3308 11.6099 10.4453 11.5092 10.5448C11.4086 10.6443 11.3296 10.7463 11.2721 10.8507C11.2146 10.9552 11.1739 11.0647 11.1499 11.1791C11.1259 11.2935 11.114 11.4303 11.114 11.5896V11.9776H8.87166V11.4104C8.87166 11.1517 8.89562 10.9204 8.94353 10.7164C8.99144 10.5124 9.06331 10.3259 9.15914 10.1567C9.25496 9.98756 9.37235 9.82338 9.51129 9.66418C9.65024 9.50497 9.81554 9.3408 10.0072 9.17164L10.4815 8.70895C10.6444 8.5597 10.7834 8.40298 10.8984 8.23881C11.0133 8.07463 11.0708 7.87811 11.0708 7.64925C11.0708 7.33084 10.9774 7.07712 10.7906 6.88806C10.6037 6.699 10.3474 6.60448 10.0216 6.60448C9.61909 6.60448 9.31725 6.74627 9.11602 7.02985C8.91478 7.31343 8.80459 7.63433 8.78542 7.99254L6.5 7.73881C6.5575 7.20149 6.68925 6.72886 6.89528 6.3209C7.1013 5.91293 7.36721 5.57463 7.69302 5.30597C8.01882 5.03731 8.38775 4.83582 8.7998 4.70149C9.21184 4.56716 9.64784 4.5 10.1078 4.5C10.539 4.5 10.9582 4.55721 11.3655 4.67164C11.7728 4.78607 12.1345 4.96517 12.4507 5.20895C12.7669 5.45274 13.0209 5.76368 13.2125 6.14179C13.4042 6.5199 13.5 6.96766 13.5 7.48507ZM11.4015 14.0821C11.4015 14.4801 11.2673 14.8159 10.999 15.0896C10.7307 15.3632 10.4001 15.5 10.0072 15.5C9.81556 15.5 9.63589 15.4652 9.46819 15.3955C9.3005 15.3259 9.15197 15.2264 9.02261 15.097C8.89324 14.9677 8.79023 14.8184 8.71357 14.6493C8.63691 14.4801 8.59858 14.296 8.59858 14.097C8.59858 13.908 8.63452 13.7264 8.70639 13.5523C8.77826 13.3781 8.87887 13.2264 9.00823 13.097C9.1376 12.9677 9.28852 12.8657 9.46101 12.7911C9.63349 12.7164 9.81556 12.6791 10.0072 12.6791C10.1989 12.6791 10.3785 12.7164 10.5462 12.7911C10.7139 12.8657 10.8624 12.9652 10.9918 13.0896C11.1212 13.2139 11.2218 13.3632 11.2937 13.5373C11.3655 13.7115 11.4015 13.8931 11.4015 14.0821Z"
          id="?"
          fill={fill}
        />
      </g>
    </g>
  </svg>
);

TooltipIcon.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  fill: PropTypes.string
};

TooltipIcon.defaultProps = {
  className: "",
  height: "14",
  width: "14",
  backgroundColor: "inherit",
  fill: "#999E9C"
};

export default TooltipIcon;
